module.exports = __webpack_public_path__ + "static/gt-logo-transparent-5aebc51f81ce0a2ded616dd9ec918de4.png";